export default "__VITE_ASSET__CtCTFgPJ__"